/* ++++++++++ --------------- USERS CONFIG : STYLES --------------- ++++++++++ */
import {pxToEm, themeV2} from "@insticator/insticator-ui";

export default {
  rolesmanagement: {
    '& .collapsable': {
      '& .innerWrap': {
        padding: 0
      },
      '&.opened': {
        overflow: 'visible',
        '& .innerWrap': {
          padding: pxToEm(16)
        }
      }
    },
    '& .sectioncard': {
      padding: 0
    },
    '& .name-roles': {
      '& tr': {
        '& td:nth-child(2)': {
          width: pxToEm(180)
        }
      }
    },
    '& .name-roles-header': {
      display: 'flex',
      justifyContent: 'space-between',
      padding: `${pxToEm(16)} ${pxToEm(50)}`,
      paddingBottom: pxToEm(12),
      '& .title': {
        margin: 0
      },
      '& .button': {
        width: 'auto',
        padding: `0 ${pxToEm(16)}`,
        height: pxToEm(34),
        fontSize: themeV2.typography.size.xsmall.fontSize
      }
    },
    '& .name-permission-denied': {
      padding: `${pxToEm(8)} ${pxToEm(50)} ${pxToEm(16)} ${pxToEm(50)}`
    },
    '& .listtable': {
      paddingBottom: pxToEm(16),
      '& tr': {
        '& .column:first-child': {
          width: pxToEm(240)
        },
        '&.expandable': {
          '& > .column': {
            zIndex: 4
          },
          '& .innerwrap': {
            overflow: 'visible'
          }
        }
      },
      '& .expandablesection': {
        boxShadow: 'none !important',
        border: 'none !important',
        '& .configcontroller': {
          '& > .title': {
            maxWidth: '75%',
            wordBreak: 'break-all',
            padding: pxToEm(8)
          },
          '& > div': {
            minWidth: pxToEm(240) // width of save & close container
          }
        }
      }
    },
    '& .actioncolumn': {
      whiteSpace: 'nowrap',
      '& .icon': {
        color: themeV2.color.base.gray.dark,
        marginRight: pxToEm(12)
      }
    },
    '& .dropdowncontainer': {
      '& > .name-menuItems': {
        zIndex: 4,
        background: themeV2.color.base.white,
        position: 'relative'
      }
    },
    '& .footer': {
      position: 'relative',
      zIndex: -1
    },
    '& .badgeimg': {
      width: pxToEm(40),
      height: pxToEm(40),
      borderRadius: pxToEm(8)
    }
  },
  // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
  [`@media only screen and (max-width:${pxToEm(1200)})`]: {
    rolesmanagement: {
      '& .name-details, & .name-permissions': {
        flexDirection: 'column !important'
      },
      '& .listtable': {
        '& .expandablesection': {
          '& .configcontroller': {
            flexDirection: 'column !important',
            alignItems: 'flex-start',
            '& .title': {
              margin: pxToEm(8),
              maxWidth: pxToEm(400)
            },
            '& > div': {
              margin: pxToEm(8)
            }
          },
          '& .footer': {
            justifyContent: 'flex-start'
          }
        },
        '& .gridset': {
          flexDirection: 'column !important'
        }
      }
    }
  }
}; 